import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { Category, CategoryTypes } from './types'

export function createCategory (data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Category>> => {
    createAlert({ code: 100, title: 'Cadastrando Categoria', message: 'Aguarde...' })(dispatch)

    return Axios
      .post('/category', data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: CategoryTypes.CATEGORY_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar a categoria')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function updateCategory (id: number|string, data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Category>> => {
    createAlert({ code: 100, title: 'Atualizando Categoria', message: 'Aguarde...' })(dispatch)
    return Axios
      .put(`/category/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: CategoryTypes.CATEGORY_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar a categoria')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function deleteCategory (id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Category>> => {
    createAlert({ code: 100, title: 'Removendo Categoria', message: 'Aguarde...' })(dispatch)
    return Axios
      .delete(`/category/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: CategoryTypes.CATEGORY_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover a categoria')
      })
      .then(async res => {
        createAlert(res)(dispatch)
        await clearAlert(1500)(dispatch)

        return res
      })
  }
}

export function getCategory (id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Category>> => {
    return Axios
      .get(`/category/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: CategoryTypes.CATEGORY_GET, payload: res.data })
        }
        return res
      })
  }
}

export function getCategoryList (params?: Record<string, string|number>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Category[]>> => {
    return Axios
      .get('/category', { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: CategoryTypes.CATEGORY_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}
